import { Failure } from "src/app/core/utils/failure";
import { UseCase } from "src/app/core/utils/usecase";
import { MinuteRepositoryBase } from "../repositories/minute-base.repository";
import { Injectable } from "@angular/core";

@Injectable()
export class DeleteActaUseCase implements UseCase<string, string | Failure> {

    constructor(private minuteRepository: MinuteRepositoryBase) {}

    async execute(param: string): Promise<string | Failure> {
        return await this.minuteRepository.deleteActa(param);
    }
}
